import { serverURL } from "../utils";

export const logError = async (errorObj) => {
  fetch(`${serverURL()}/log-error`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ error: errorObj }),
  });
};
